/* eslint-disable camelcase */
export const ANALYTICS_START = 'start';
export const ANALYTICS_END = 'complete';
export var AnalyticsEvents;
(function (AnalyticsEvents) {
    AnalyticsEvents["HOME"] = "lokalbank_web_home";
    AnalyticsEvents["PAYMENT"] = "lokalbank_web_payment";
    AnalyticsEvents["BILLS"] = "lokalbank_web_bills";
    AnalyticsEvents["EFAKTURA"] = "lokalbank_web_efaktura";
    AnalyticsEvents["BATCH_EFAKTURA"] = "lokalbank_web_batch_efaktura";
    AnalyticsEvents["ADDRECURRINGPAYMENT"] = "lokalbank-web_recurringpayment";
    AnalyticsEvents["AVTALEGIRO"] = "lokalbank-web-avtalegiro";
    AnalyticsEvents["TRANSFER"] = "lokalbank_web_transfer";
    AnalyticsEvents["TRANSACTION"] = "lokalbank_web_transaction";
    AnalyticsEvents["DOWNPAYMENT"] = "lokalbank_web_loan_downpayment";
})(AnalyticsEvents || (AnalyticsEvents = {}));
export const trackEvent = (event, category, action, label) => {
    window?.dataLayer?.push({
        event,
        event_category: category,
        event_action: action,
        event_label: label,
    });
};
export const trackPageView = (path) => {
    window?.dataLayer?.push({
        event: 'pageview',
        page: {
            path,
        },
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5hbHl0aWNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NlcnZpY2VzL2FuYWx5dGljcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSw4QkFBOEI7QUFFOUIsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLE9BQU8sQ0FBQztBQUN2QyxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsVUFBVSxDQUFDO0FBRXhDLE1BQU0sQ0FBTixJQUFZLGVBV1g7QUFYRCxXQUFZLGVBQWU7SUFDdkIsOENBQTJCLENBQUE7SUFDM0Isb0RBQWlDLENBQUE7SUFDakMsZ0RBQTZCLENBQUE7SUFDN0Isc0RBQW1DLENBQUE7SUFDbkMsa0VBQStDLENBQUE7SUFDL0MseUVBQXNELENBQUE7SUFDdEQsMERBQXVDLENBQUE7SUFDdkMsc0RBQW1DLENBQUE7SUFDbkMsNERBQXlDLENBQUE7SUFDekMsaUVBQThDLENBQUE7QUFDbEQsQ0FBQyxFQVhXLGVBQWUsS0FBZixlQUFlLFFBVzFCO0FBU0QsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLENBQUMsS0FBc0IsRUFBRSxRQUFnQixFQUFFLE1BQWUsRUFBRSxLQUFjLEVBQVEsRUFBRTtJQUMxRyxNQUFNLEVBQUUsU0FBUyxFQUFFLElBQUksQ0FBQztRQUNwQixLQUFLO1FBQ0wsY0FBYyxFQUFFLFFBQVE7UUFDeEIsWUFBWSxFQUFFLE1BQU07UUFDcEIsV0FBVyxFQUFFLEtBQUs7S0FDSCxDQUFDLENBQUM7QUFDekIsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQUMsSUFBWSxFQUFRLEVBQUU7SUFDaEQsTUFBTSxFQUFFLFNBQVMsRUFBRSxJQUFJLENBQUM7UUFDcEIsS0FBSyxFQUFFLFVBQVU7UUFDakIsSUFBSSxFQUFFO1lBQ0YsSUFBSTtTQUNQO0tBQ0osQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxDQUFDIn0=